import {useEffect, useState} from 'react';
import {Table, Row, Col, Typography, Button, Space} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchBundleOutwardPackingSlipData,
  fetchBundleOutwardPackingSlipbundles,
} from '../../slices/bundleoutward';
import {PrinterOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import {useParams} from 'react-router-dom';

const {Title, Text} = Typography;

function DraftPrintBundleOutWard() {
  const {id} = useParams();
  const [bundleOutwardData, setBundleOutwardData] = useState(null);
  const [bundleOutwardPackingSlip, setbundleOutwardPackingSlip] =
    useState(null);
  const dispatch = useDispatch();

  const {status} = useSelector(state => state.bundleoutward);

  let serialCounter = 1;

  const transformedRows = bundleOutwardPackingSlip?.bundles?.map((row, idx) => {
    if (row.type === 'data') {
      const dataRow = {
        key: `data-${idx}`,
        type: 'data',
        sr_no: serialCounter,
        bundle_no: row.bundle_no,
        die_number: row.die_number,
        die_diagram: row.die_diagram,
        die_dimensions: row.die_dimensions,
        length: row.length,
        pieces: row.pieces,
        net_weight: row.net_weight,
        gross_weight: row.gross_weight,
      };
      serialCounter++;
      return dataRow;
    } else if (row.type === 'subtotal') {
      return {
        key: `subtotal-${idx}`,
        type: 'subtotal',
        bundle_no: '',
        die_number: '',
        die_diagram: '',
        die_dimensions: row.description,
        length: '',
        pieces: row.pieces,
        net_weight: row.net_weight_kg,
        gross_weight: row.gross_weight_kg,
      };
    }
  });

  // Updated print styles to match the image
  const printStyles = `
    @media print {
      @page {
        size: A4 portrait;
        margin: 8mm;
      }

      * {
        font-size: 10px !important;
        line-height: 1.2 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      body {
        margin: 0 !important;
        padding: 0 !important;
        font-family: 'Arial', sans-serif !important;
      }

      .bundle-outward-container {
        padding: 0 !important;
        margin: 0 !important;
        max-width: 100% !important;
      }

      .company-header {
        text-align: center !important;
        margin-bottom: 12px !important;
        border-bottom: 1.5px solid #12406a !important;
        padding-bottom: 6px !important;
      }

      .company-title {
        font-size: 16px !important;
        font-weight: bold !important;
        color: #12406a !important;
        margin: 0 0 2px 0 !important;
      }

      .document-title {
        font-size: 12px !important;
        color: #12406a !important;
        margin: 0 !important;
      }
.info-section {
  margin: 8px 0 !important;
}

.info-row {
  display: flex !important;
  justify-content: space-between !important;
  margin-bottom: 8px !important;
  width: 100% !important;
}

.customer-info {
  flex: 3 !important; /* 18/24 = 3/4 of the width */
  padding-right: 15px !important;
}

.order-info {
  flex: 1 !important; /* 6/24 = 1/4 of the width */
  padding-left: 15px !important;
}
      .info-item {
        margin-bottom: 3px !important;
        display: flex !important;
        align-items: flex-start !important;
      }

      .info-label {
        font-weight: bold !important;
        min-width: 100px !important;
        color: #333 !important;
      }

      .info-value {
        flex: 1 !important;
        color: black !important;
      }

      .table-container {
        margin: 12px 0 !important;
      }

      .ant-table {
        width: 100% !important;
        border-collapse: collapse !important;
        margin: 0 !important;
      }

      .ant-table-thead > tr > th {
        background-color: #12406a !important;
        color: white !important;
        font-weight: bold !important;
        text-align: center !important;
        padding: 4px 2px !important;
        border: 1px solid #12406a !important;
        font-size: 9px !important;
        vertical-align: middle !important;
      }

      .ant-table-tbody > tr > td {
        text-align: center !important;
        padding: 3px 2px !important;
        border: 1px solid #ddd !important;
        font-size: 9px !important;
        vertical-align: middle !important;
      }

      .ant-table-summary > tr > td {
        border: 1px solid #ddd !important;
        font-weight: bold !important;
        padding: 4px 2px !important;
        text-align: center !important;
       
        font-size: 9px !important;
        vertical-align: middle !important;
      }

      .subtotal-row td {
      
        font-weight: bold !important;
      }

      .page-break {
        page-break-before: always !important;
        margin-top: 0 !important;
        padding-top: 15px !important;
      }

      .no-print {
        display: none !important;
      }

      .screen-only {
        display: none !important;
      }

      .print-only {
        display: block !important;
      }

      img {
        max-width: 50px !important;
        max-height: 50px !important;
        object-fit: contain !important;
      }

      .ant-row {
        display: flex !important;
        margin: 0 !important;
      }

      .ant-col {
        padding: 0 !important;
      }

      .ant-table-container {
        border: none !important;
      }

      .ant-table-content {
        border: none !important;
      }
    }

    @media screen {
      .print-only {
        display: none !important;
      }
      
      .screen-only {
        display: block !important;
      }
      
      .bundle-outward-container {
        max-width: 1200px;
        margin: 20px auto;
        padding: 0 20px;
      }
    }
  `;

  useEffect(() => {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = printStyles;
    document.head.appendChild(styleEl);

    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const fetchData = async () => {
    try {
      const response = await dispatch(
        fetchBundleOutwardPackingSlipData({id: id}),
      ).unwrap();
      setBundleOutwardData(response.data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  };

  const fetchPackingSlipData = async () => {
    try {
      const response = await dispatch(
        fetchBundleOutwardPackingSlipbundles({id: id}),
      ).unwrap();
      setbundleOutwardPackingSlip(response.data);
    } catch (error) {
      console.error('Failed to fetch packing slip:', error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchPackingSlipData();
  }, [id]);

  const columnSummary = [
    {
      title: 'SR NO',
      dataIndex: 'sr_no',
      key: 'sr_no',
      align: 'center',
      width: 60,
      render: (_text, _record, index) => index + 1,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'PROFILE NO',
      dataIndex: 'die_number',
      key: 'die_number',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'PROFILE IMAGE',
      dataIndex: 'image',
      key: 'image',
      width: 100,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
      render: (text, record) => {
        if (record.die_diagram) {
          return (
            <img
              src={record.die_diagram}
              alt="Section Image"
              style={{
                maxWidth: '90px',
                maxHeight: '90px',
                objectFit: 'contain',
              }}
            />
          );
        }
        return '-';
      },
      align: 'center',
    },
    {
      title: 'DESCRIPTION',
      dataIndex: 'die_dimensions',
      key: 'die_dimensions',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'ALLOY & TEMPER',
      dataIndex: 'alloy & temper',
      key: 'alloy & temper',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'LENGTH (MM)',
      dataIndex: 'length',
      key: 'length',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'PIECES',
      dataIndex: 'total_pieces',
      key: 'total_pieces',
      align: 'center',
      width: 60,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'TOTAL BUNDLE',
      dataIndex: 'total_bundles',
      key: 'total_bundles',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'NET WEIGHT (KG)',
      dataIndex: 'total_net_weight',
      key: 'total_net_weight',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'GROSS WEIGHT (KG)',
      dataIndex: 'total_gross_weight',
      key: 'total_gross_weight',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
  ];

  const columns = [
    {
      title: 'SR NO',
      dataIndex: 'sr_no',
      key: 'sr_no',
      align: 'center',
      width: 60,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'BUNDLE NO',
      dataIndex: 'bundle_no',
      key: 'bundle_no',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'PROFILE NO',
      dataIndex: 'die_number',
      key: 'die_number',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    // {
    //   title: 'PROFILE IMAGE',
    //   dataIndex: 'die_diagram',
    //   key: 'die_diagram',
    //   width: 100,
    //   onHeaderCell: () => ({
    //     style: {
    //       backgroundColor: '#12406a',
    //       color: 'white',
    //       textAlign: 'center',
    //     },
    //   }),
    //   render: (die_diagram) => {

    //     if (die_diagram) {
    //       return (
    //         <img
    //           src={die_diagram}
    //           alt="Section Image"
    //           style={{
    //             maxWidth: '90px',
    //             maxHeight: '90px',
    //             objectFit: 'contain',
    //           }}
    //         />
    //       );
    //     }
    //     return '-';
    //   },
    //   align: 'center',
    // },
    {
      title: 'DESCRIPTION',
      dataIndex: 'die_dimensions',
      key: 'die_dimensions',
      align: 'center',
      width: 150,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'LENGTH (MM)',
      dataIndex: 'length',
      key: 'length',
      align: 'center',
      width: 80,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'PIECES',
      dataIndex: 'pieces',
      key: 'pieces',
      align: 'center',
      width: 60,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'NET WEIGHT (KG)',
      dataIndex: 'net_weight',
      key: 'net_weight',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
    {
      title: 'GROSS WEIGHT (KG)',
      dataIndex: 'gross_weight',
      key: 'gross_weight',
      align: 'center',
      width: 100,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#12406a',
          color: 'white',
          textAlign: 'center',
        },
      }),
    },
  ];

  const InfoItem = ({label, value}) => (
    <div className="info-item">
      <Text className="info-label" strong>
        {label}
      </Text>
      <Text className="info-value">{value || '-'}</Text>
    </div>
  );
  return (
    <div className="bundle-outward-container">
      {/* Screen View */}
      <div className="screen-only">
        <Space direction="vertical" size="large" style={{width: '100%'}}>
          {/* Header */}
          <div
            style={{
              textAlign: 'center',
              borderBottom: '1px solid #000',
              paddingBottom: '8px',
            }}
          >
            <Title level={3} style={{margin: 0}}>
              Alux ERP
            </Title>
            <Title level={4} style={{margin: '4px 0 0 0', fontWeight: 400}}>
              PACKING SLIP SUMMARY
            </Title>
            <Title level={4} style={{margin: '4px 0 0 0', fontWeight: 500}}>
              DRAFT
            </Title>
          </div>

          {/* Information Section */}
          <Row gutter={16}>
            <Col span={18}>
              <div style={{padding: '8px'}}>
                <InfoItem
                  label="Customer Name : "
                  value={bundleOutwardData?.customer_name}
                />
                <InfoItem
                  label="Address : "
                  value={bundleOutwardData?.office_address}
                />
                <InfoItem
                  label="Mobile : "
                  value={
                    bundleOutwardData?.phone_number
                      ? `+${bundleOutwardData.phone_number}`
                      : null
                  }
                />
                <InfoItem
                  label="Transporter Name : "
                  value={bundleOutwardData?.transporter_name}
                />
              </div>
            </Col>
            <Col span={6}>
              <div style={{padding: '8px'}}>
                <InfoItem
                  label="IWO NO : "
                  value={bundleOutwardData?.order_no}
                />
                <InfoItem
                  label="Dispatch Date : "
                  value={
                    bundleOutwardData?.dispatched_date
                      ? dayjs(bundleOutwardData.dispatched_date).format(
                          'DD-MM-YYYY',
                        )
                      : 'N/A'
                  }
                />
                <InfoItem
                  label="Packing Slip No : "
                  value={bundleOutwardData?.slip_no}
                />
                <InfoItem
                  label="Vehicle No : "
                  value={bundleOutwardData?.vehicle_no}
                />
                <InfoItem
                  label="Remarks : "
                  value={bundleOutwardData?.remarks}
                />
              </div>
            </Col>
          </Row>

          {/* Summary Table */}
          <div className="table-container">
            <Table
              columns={columnSummary}
              dataSource={bundleOutwardData?.summary}
              pagination={false}
              bordered
              rowKey="sr_no"
              loading={status === 'loading'}
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={6} align="center">
                    <Text strong>TOTAL</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={6} align="center">
                    <Text strong>
                      {bundleOutwardData?.total_summary?.total_pieces}
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={7} align="center">
                    <Text strong>
                      {bundleOutwardData?.total_summary?.total_bundles}
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={8} align="center">
                    <Text strong>
                      {bundleOutwardData?.total_summary?.total_net_weight}
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={9} align="center">
                    <Text strong>
                      {bundleOutwardData?.total_summary?.total_gross_weight}
                    </Text>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
          </div>
          <div
            style={{
              textAlign: 'center',
              borderBottom: '1px solid #000',
              paddingBottom: '8px',
            }}
          >
            <Title level={3} style={{margin: 0}}>
              Alux ERP
            </Title>
            <Title level={4} style={{margin: '4px 0 0 0', fontWeight: 400}}>
              PACKING SLIP
            </Title>
            <Title level={4} style={{margin: '4px 0 0 0', fontWeight: 500}}>
              DRAFT
            </Title>
          </div>
          <Row gutter={16}>
            <Col span={18}>
              <div style={{padding: '8px'}}>
                <InfoItem
                  label="Customer Name : "
                  value={bundleOutwardData?.customer_name}
                />
                <InfoItem
                  label="Address : "
                  value={bundleOutwardData?.office_address}
                />
                <InfoItem
                  label="Mobile : "
                  value={
                    bundleOutwardData?.phone_number
                      ? `+${bundleOutwardData.phone_number}`
                      : null
                  }
                />
                <InfoItem
                  label="Transporter Name : "
                  value={bundleOutwardData?.transporter_name}
                />
              </div>
            </Col>
            <Col span={6}>
              <div style={{padding: '8px'}}>
                <InfoItem
                  label="IWO NO : "
                  value={bundleOutwardData?.order_no}
                />
                <InfoItem
                  label="Dispatch Date : "
                  value={
                    bundleOutwardData?.dispatched_date
                      ? dayjs(bundleOutwardData.dispatched_date).format(
                          'DD-MM-YYYY',
                        )
                      : 'N/A'
                  }
                />
                <InfoItem
                  label="Packing Slip No : "
                  value={bundleOutwardData?.slip_no}
                />
                <InfoItem
                  label="Vehicle No : "
                  value={bundleOutwardData?.vehicle_no}
                />
                <InfoItem
                  label="Remarks : "
                  value={bundleOutwardData?.remarks}
                />
              </div>
            </Col>
          </Row>
          {/* Detail Table */}
          <div className="table-container">
            <Table
              columns={columns}
              dataSource={transformedRows}
              pagination={false}
              bordered
              rowKey="sr_no"
              rowClassName={record =>
                record.type === 'subtotal' ? 'subtotal-row' : ''
              }
              loading={status === 'loading'}
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={4} align="center">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.description}
                    </strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={4}
                    align="center"
                  ></Table.Summary.Cell>
                  <Table.Summary.Cell index={5} align="center">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.total_pieces}
                    </strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={6} align="center">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.total_net_weight}
                    </strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={7} align="center">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.total_gross_weight}
                    </strong>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
          </div>

          {/* Print Button */}
          <div style={{textAlign: 'center', padding: '20px'}}>
            <Button
              onClick={handlePrint}
              type="primary"
              size="large"
              icon={<PrinterOutlined />}
            >
              Print
            </Button>
          </div>
        </Space>
      </div>

      {/* Print View */}
      <div className="print-only">
        {/* Header Section */}
        <div className="company-header">
          <Title className="company-title" level={3}>
            Alux ERP
          </Title>
          <Title className="document-title" level={4}>
            PACKING SLIP SUMMARY
          </Title>
          <Title className="document-title" level={4}>
            DRAFT
          </Title>
        </div>

        {/* Information Section */}
        <div className="info-section">
          <div className="info-row">
            <div className="customer-info">
              <InfoItem
                label="Customer Name : "
                value={bundleOutwardData?.customer_name}
              />
              <InfoItem
                label="Address : "
                value={bundleOutwardData?.office_address}
              />
              <InfoItem
                label="Mobile : "
                value={
                  bundleOutwardData?.phone_number
                    ? `+${bundleOutwardData.phone_number}`
                    : null
                }
              />
              <InfoItem
                label="Transporter Name : "
                value={bundleOutwardData?.transporter_name}
              />
            </div>
            <div className="order-info">
              <InfoItem label="IWO NO : " value={bundleOutwardData?.order_no} />
              <InfoItem
                label="Dispatch Date : "
                value={
                  bundleOutwardData?.dispatched_date
                    ? dayjs(bundleOutwardData.dispatched_date).format(
                        'DD-MM-YYYY',
                      )
                    : 'N/A'
                }
              />
              <InfoItem
                label="Packing Slip No : "
                value={bundleOutwardData?.slip_no}
              />
              <InfoItem
                label="Vehicle No : "
                value={bundleOutwardData?.vehicle_no}
              />
              <InfoItem label="Remarks : " value={bundleOutwardData?.remarks} />
            </div>
          </div>
        </div>

        {/* Summary Table */}
        <div className="table-container">
          <Table
            columns={columnSummary}
            dataSource={bundleOutwardData?.summary}
            pagination={false}
            bordered
            rowKey="sr_no"
            loading={status === 'loading'}
            size="small"
            summary={() => (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={6} align="right">
                  <strong>TOTAL</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align="center">
                  <strong>
                    {bundleOutwardData?.total_summary?.total_pieces}
                  </strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} align="center">
                  <strong>
                    {bundleOutwardData?.total_summary?.total_bundles}
                  </strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8} align="center">
                  <strong>
                    {bundleOutwardData?.total_summary?.total_net_weight}
                  </strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={9} align="center">
                  <strong>
                    {bundleOutwardData?.total_summary?.total_gross_weight}
                  </strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          />
        </div>

        {/* Page Break for Print */}
        <div className="page-break">
          <div className="company-header">
            <Title className="company-title" level={3}>
              Alux ERP
            </Title>
            <Title className="document-title" level={4}>
              PACKING SLIP
            </Title>
            <Title className="document-title" level={4}>
              DRAFT
            </Title>
          </div>

          {/* Repeated Information Section */}
          <div className="info-section">
            <div className="info-row">
              <div className="customer-info">
                <InfoItem
                  label="Customer Name : "
                  value={bundleOutwardData?.customer_name}
                />
                <InfoItem
                  label="Address : "
                  value={bundleOutwardData?.office_address}
                />
                <InfoItem
                  label="Mobile : "
                  value={
                    bundleOutwardData?.phone_number
                      ? `+${bundleOutwardData.phone_number}`
                      : null
                  }
                />
                <InfoItem
                  label="Transporter Name : "
                  value={bundleOutwardData?.transporter_name}
                />
              </div>
              <div className="order-info">
                <InfoItem
                  label="IWO NO : "
                  value={bundleOutwardData?.order_no}
                />
                <InfoItem
                  label="Dispatch Date : "
                  value={
                    bundleOutwardData?.dispatched_date
                      ? dayjs(bundleOutwardData.dispatched_date).format(
                          'DD-MM-YYYY',
                        )
                      : 'N/A'
                  }
                />
                <InfoItem
                  label="Packing Slip No : "
                  value={bundleOutwardData?.slip_no}
                />
                <InfoItem
                  label="Vehicle No : "
                  value={bundleOutwardData?.vehicle_no}
                />
                <InfoItem
                  label="Remarks : "
                  value={bundleOutwardData?.remarks}
                />
              </div>
            </div>
          </div>

          {/* Detail Table */}
          <div className="table-container">
            <Table
              columns={columns}
              dataSource={transformedRows}
              pagination={false}
              bordered
              rowKey="sr_no"
              rowClassName={record =>
                record.type === 'subtotal' ? 'subtotal-row' : ''
              }
              loading={status === 'loading'}
              size="small"
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={4} align="right">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.description}
                    </strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={4}
                    align="center"
                  ></Table.Summary.Cell>
                  <Table.Summary.Cell index={5} align="center">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.total_pieces}
                    </strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={6} align="center">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.total_net_weight}
                    </strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={7} align="center">
                    <strong>
                      {bundleOutwardPackingSlip?.summary.total_gross_weight}
                    </strong>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DraftPrintBundleOutWard;
